import SplideCarousel from './splide.js';
import Tabs from './tabs.js';
import TOC from './toc.js';
import Searchform from './searchform.js';
import QuantityInput from './quantity-input.js';
import './navigation.js';
import './quantity-input-cart.js';
import GSAPAnimations from './animations.js';

const splideCarousel = new SplideCarousel();
splideCarousel.init();

Tabs();
Searchform();
TOC();
QuantityInput();

// Initialize GSAP animations when GSAP is loaded from CDN
const initGSAPAnimations = () => {
  if (window.gsap && window.ScrollTrigger) {
    const animations = new GSAPAnimations();
    animations.init();

    // Make available globally for debugging and dynamic content
    window.icebathsAnimations = animations;
  }
};

// Check if GSAP is already loaded, otherwise wait for it
if (window.gsap && window.ScrollTrigger) {
  initGSAPAnimations();
} else {
  // Wait for GSAP to load from CDN
  const checkGSAP = setInterval(() => {
    if (window.gsap && window.ScrollTrigger) {
      clearInterval(checkGSAP);
      initGSAPAnimations();
    }
  }, 50);

  // Timeout after 5 seconds
  setTimeout(() => clearInterval(checkGSAP), 5000);
}


